/* Royal Step — falling sparkles, cursor stardust. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- seat the castle right where the night-plum footer begins ----------
  function seatCastle() {
    var castle = document.querySelector('.rs-castle');
    if (!castle) return;
    var footer = castle.nextElementSibling;
    if (!footer) return;
    var all = footer.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var bg = getComputedStyle(all[i]).backgroundColor;
      if (bg === 'rgb(90, 35, 115)') { all[i].parentNode.insertBefore(castle, all[i]); return; }
    }
  }
  document.addEventListener('DOMContentLoaded', seatCastle);

  if (reduce) return;

  // ---------- sparkles ----------
  var canvas = document.createElement('canvas');
  canvas.id = 'rs-sparkles';
  canvas.setAttribute('aria-hidden', 'true');
  var ctx = canvas.getContext('2d');
  var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  var COLORS = ['#FF8FC7', '#F3B9E0', '#C9A7F2', '#9FD3FF', '#F3E1A6', '#E2C47A', '#FFFFFF'];
  var flakes = [], trail = [];

  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = W * dpr; canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function makeFlake(top) {
    return {
      x: Math.random() * W,
      y: top ? -10 - Math.random() * 40 : Math.random() * H,
      r: 1.4 + Math.random() * 3.2,
      vy: 0.25 + Math.random() * 0.55,
      sway: 0.6 + Math.random() * 1.2,
      phase: Math.random() * Math.PI * 2,
      tw: 0.02 + Math.random() * 0.03,
      c: COLORS[(Math.random() * COLORS.length) | 0],
      star: Math.random() < 0.55
    };
  }
  function star(x, y, r, a, c) {
    ctx.globalAlpha = a;
    ctx.fillStyle = c;
    ctx.beginPath();
    ctx.moveTo(x, y - r * 2);
    ctx.quadraticCurveTo(x, y, x + r * 2, y);
    ctx.quadraticCurveTo(x, y, x, y + r * 2);
    ctx.quadraticCurveTo(x, y, x - r * 2, y);
    ctx.quadraticCurveTo(x, y, x, y - r * 2);
    ctx.fill();
  }
  function dot(x, y, r, a, c) {
    ctx.globalAlpha = a;
    ctx.fillStyle = c;
    ctx.beginPath();
    ctx.arc(x, y, r * 0.6, 0, Math.PI * 2);
    ctx.fill();
  }
  var t = 0, running = true;
  function frame() {
    if (!running) return;
    t += 1;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.y += f.vy;
      f.phase += f.tw;
      var x = f.x + Math.sin(f.phase) * f.sway * 6;
      var a = 0.35 + 0.45 * (0.5 + 0.5 * Math.sin(f.phase * 2));
      (f.star ? star : dot)(x, f.y, f.r, a, f.c);
      if (f.y > H + 12) flakes[i] = makeFlake(true);
    }
    for (var j = trail.length - 1; j >= 0; j--) {
      var p = trail[j];
      p.life -= 1; p.y += p.vy; p.x += p.vx;
      if (p.life <= 0) { trail.splice(j, 1); continue; }
      star(p.x, p.y, p.r * (p.life / p.max), p.life / p.max, p.c);
    }
    ctx.globalAlpha = 1;
    requestAnimationFrame(frame);
  }
  function start() {
    document.body.appendChild(canvas);
    resize();
    var n = W < 750 ? 16 : 30;
    for (var i = 0; i < n; i++) flakes.push(makeFlake(false));
    requestAnimationFrame(frame);
  }
  window.addEventListener('resize', resize);
  document.addEventListener('visibilitychange', function () {
    running = !document.hidden;
    if (running) requestAnimationFrame(frame);
  });

  // cursor stardust on desktop
  if (window.matchMedia('(pointer: fine)').matches) {
    var last = 0;
    window.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - last < 45) return;
      last = now;
      trail.push({ x: e.clientX, y: e.clientY, vx: (Math.random() - 0.5) * 0.6, vy: 0.4 + Math.random() * 0.6, r: 1.6 + Math.random() * 1.8, life: 38, max: 38, c: COLORS[(Math.random() * 3) | 0] });
      if (trail.length > 40) trail.shift();
    }, { passive: true });
  }

  // Start sparkles only after the page has fully loaded, so they never slow the first paint.
  function startWhenIdle() {
    var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(start); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  startWhenIdle();
})();
